import QueryProvider from './QueryProvider';
import { AuthProvider } from '../../auth';

/**
 * Composes all app-level providers.
 *
 * Order matters:
 * 1. QueryProvider - API caching layer
 * 2. AuthProvider - User authentication state
 */
export default function AppProviders({ children }) {
  return (
    <QueryProvider>
      <AuthProvider>
        {children}
      </AuthProvider>
    </QueryProvider>
  );
}
